// Add shared constants here and export them.
// Example:
// const MAX_FILE_SIZE_MB = 10;
// module.exports = { MAX_FILE_SIZE_MB };

module.exports = {};
